import Layout from '../views/layout/Layout'
import RouteView from '../views/layout/RouteView'

const salesBusinessRoutes = {
  path: '/salesBusiness',
  component: Layout,
  name: 'salesBusiness',
  redirect: '/salesBusiness/customerManagement/profiles',
  defaultPath: '/salesBusiness/customerManagement/profiles',
  meta: { title: '客户运营', icon: 'financialSettlement', alwaysShow: true },
  children: [
    {
      path: 'businessPerformance',
      name: 'businessPerformance',
      sort: 3,
      component: RouteView,
      redirect: '/salesBusiness/businessPerformance/dashboard',
      meta: { title: '商务业绩', icon: 'chart_bar_fill' },
      children: [
        {
          path: 'dashboard',
          alias: '/businessPerformance/dashboard',
          name: 'businessPerformanceDashboard',
          sort: 0,
          morePath: '/salesBusiness/businessPerformance/dashboard',
          component: () => import('@/views/salesBusiness/businessPerformance/dashboard'),
          meta: { title: '商务业绩看板', icon: 'chart_bar_fill' }
        },
        {
          path: 'targets',
          alias: '/businessPerformance/targets',
          name: 'businessPerformanceTargets',
          sort: 1,
          morePath: '/salesBusiness/businessPerformance/targets',
          component: () => import('@/views/salesBusiness/businessPerformance/targets'),
          meta: { title: '商务目标设置', icon: 'chart_bar_fill' }
        }
      ]
    },
    {
      path: 'customerManagement',
      name: 'customerManagement',
      sort: 0,
      component: RouteView,
      meta: { title: '客户管理', icon: 'cus-mana' },
      children: [
        {
          path: 'profiles',
          alias: '/businessCenter/rechargeCustomer/customerProfilingList',
          name: 'customerProfilingList',
          sort: 0,
          morePath: '/salesBusiness/customerManagement/profiles',
          component: () => import('@/views/recharge/customerProfiling/index'),
          meta: { title: '客户档案', icon: 'customer-list' }
        },
        {
          path: 'statistics',
          alias: '/businessCenter/rechargeCustomer/customerProfilingStatistics',
          name: 'customerProfilingStatistics',
          sort: 1,
          morePath: '/salesBusiness/customerManagement/statistics',
          component: () => import('@/views/recharge/customerProfilingStatistics/index'),
          meta: { title: '客户统计', icon: 'customer-recharge-add-list' }
        },
        {
          path: 'groups',
          alias: '/businessCenter/rechargeCustomer/companyGroupInfoList',
          name: 'companyGroupInfoList',
          sort: 2,
          morePath: '/salesBusiness/customerManagement/groups',
          component: () => import('@/views/recharge/companyGroupInfo/index'),
          meta: { title: '客户集团', icon: 'product-list' }
        },
        {
          path: 'profileDetail',
          alias: '/businessCenter/rechargeCustomer/customerProfilingListDetail',
          name: 'customerProfilingListDetail',
          component: () => import('@/views/recharge/customerProfiling/edit'),
          meta: { title: '客户详情' },
          hidden: true
        },
        {
          path: 'profileEdit',
          alias: '/businessCenter/rechargeCustomer/customerProfilingListEdit',
          name: 'customerProfilingListEdit',
          component: () => import('@/views/recharge/customerProfiling/update'),
          meta: { title: '编辑客户' },
          hidden: true
        },
        {
          path: 'profileContractSettlement',
          alias: '/businessCenter/rechargeCustomer/customerProfilingListContractSettlement',
          name: 'customerProfilingListContractSettlement',
          component: () => import('@/views/recharge/customerProfiling/card-detail'),
          meta: { title: '客户合同与结算详情' },
          hidden: true
        },
        {
          path: 'profileData',
          alias: '/businessCenter/rechargeCustomer/customerProfilingDataList',
          name: 'customerProfilingDataList',
          component: () => import('@/views/recharge/customerProfilingData/index'),
          meta: { title: '客户数据详情' },
          hidden: true
        },
        {
          path: 'profileCreate',
          alias: ['/recharge/addCustomerProfiling', '/rechargeCustomer/addCustomerProfiling'],
          name: 'addCustomerProfiling',
          component: () => import('@/views/recharge/customerProfiling/add'),
          meta: { title: '新增客户' },
          hidden: true
        },
        {
          path: 'statisticsColumns',
          alias: '/rechargeCustomer/customerProfilingStatisticsPersonalized',
          name: 'customerProfilingStatisticsPersonalized',
          component: () => import('@/views/recharge/customerProfilingStatistics/customerProfilingStatisticsPersonalized'),
          meta: { title: '客户统计自定义列表' },
          hidden: true
        },
        {
          path: 'accountCreate',
          alias: '/recharge/addCompany',
          name: 'addCompany',
          component: () => import('@/views/recharge/companyInfo/add'),
          meta: { title: '新增广告主' },
          hidden: true
        },
        {
          path: 'accountEdit',
          alias: '/recharge/updateCompany',
          name: 'updateCompany',
          component: () => import('@/views/recharge/companyInfo/update'),
          meta: { title: '编辑广告主' },
          hidden: true
        },
        {
          path: 'accountDetail',
          alias: '/recharge/companyDetailAndHistory',
          name: 'companyDetailAndHistory',
          component: () => import('@/views/recharge/companyInfo/companyDetailAndHistory'),
          meta: { title: '广告主详情与账单流水' },
          hidden: true
        }
      ]
    },
    {
      path: 'customerDevelopment',
      name: 'customerDevelopment',
      sort: 1,
      component: RouteView,
      meta: { title: '客户拓展', icon: 'customer-money-list' },
      children: [{
        path: 'followUp',
        alias: '/salesBusiness/customerBusinessProfilingManager/customerBusinessProfiling',
        name: 'customerBusinessProfiling',
        morePath: '/salesBusiness/customerDevelopment/followUp',
        component: () => import('@/views/salesBusiness/customerBusinessProfiling/index'),
        meta: { title: '客户跟进', icon: 'customer-money-list' }
      }]
    },
    {
      path: 'customerService',
      name: 'customerService',
      sort: 2,
      component: RouteView,
      meta: { title: '客户服务', icon: 'big-ad' },
      children: [
        {
          path: 'announcements',
          alias: '/businessCenter/miniAppManager/miniAppMessage',
          name: 'miniAppMessage',
          morePath: '/salesBusiness/customerService/announcements',
          component: () => import('@/views/miniAppManager/miniAppMessage/index'),
          meta: { title: '公告管理', icon: 'customer-list' }
        },
        {
          path: 'miniUsers',
          alias: ['/businessCenter/miniAppManager/miniUserList', '/businessCenter/rechargeCustomer/miniUserList'],
          name: 'miniUserList',
          morePath: '/salesBusiness/customerService/miniUsers',
          component: () => import('@/views/recharge/miniUser/index'),
          meta: { title: '小程序用户', icon: 'ums-admin' }
        }
      ]
    }
  ]
}

export default salesBusinessRoutes



// WEBPACK FOOTER //
// ./src/router/sales-business.js